var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$t('error.title'))}}),_c('v-btn',{staticClass:"home_button",attrs:{"to":`/${_vm.$i18n.locale}/home`}},[_vm._v(" Home page ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }